<template>
  <b-modal v-bind:id="id"
          class="learning-guide-modal"
          ref="modal"
          centered
          hide-header
          hide-footer>
    <slot>
      <div class="domain-guide-container">
        <div class="domain-guide-header">{{ $t('domain.tutorial.title' )}}</div>
        <div class="domain-guide-description"
          v-html="$t('domain.tutorial.section')" />
        <div class="domain-guide-example">
          <img src="/static/images/img-sam-info-card.png" alt="icon" />
        </div>
        <div class="domain-guide-icon">
          <img src="/static/images/group-3.png" alt="icon" />
        </div>
        <div class="button-container">
          <button type="button" @click="handleSubmit">{{ $t('domain.tutorial.button') }}</button>
        </div>
      </div>
    </slot>
  </b-modal>
</template>

<script>
  export default {
    name: 'cat-domain-guide',

    props: {
      id: String,
    },

    methods: {
      handleSubmit() {
        this.$refs.modal.hide();
      },
    },

  };
</script>

<style lang="scss" scoped>
  .domain-guide-container {
    position: relative;
    background: url('/static/images/bg-my-level-info.png') center center;
    background-repeat: no-repeat;
    background-size: cover;

    .domain-guide-header {
      color: #00c896;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      padding: 12% 12% 4% 12%;
    }

    .domain-guide-description {
      font-size: 16px;
      text-align: center;
      color: rgba(0, 0, 0, 0.87);
      margin-left: auto;
      margin-right: auto;
      padding: 2% 14% 2% 14%;
    }

    .domain-guide-example {
      text-align: center;
      padding-top: 2%;
    }

    .domain-guide-icon {
      text-align: center;
      padding-top: 2%;
    }

    .button-container {
      text-align: center;
      padding-bottom: 12%;

      button {
        border-radius: 4px;
        background-color: #00c896;
        color: #ffffff;
        border: 0;
        padding: 2% 22%;
        cursor: pointer;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// CatDomainGuide.vue?ee5ca2cc